import { render, staticRenderFns } from "./iframe-login-card.vue?vue&type=template&id=139f9aac&scoped=true"
import script from "./iframe-login-card.vue?vue&type=script&lang=js"
export * from "./iframe-login-card.vue?vue&type=script&lang=js"
import style0 from "./iframe-login-card.vue?vue&type=style&index=0&id=139f9aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139f9aac",
  null
  
)

export default component.exports